import React, { useContext, useEffect } from 'react'
import Select from 'react-select'
import FormDataContext from '../../../Contexts/FormData.context'
import { formActionEnum, jsonKeyMapping } from '../../../Config/Constants'
import produce from 'immer'
import { TemplateObject } from '../../../Models/TemplateObject'
import InputWrapper from './InputWrapper'
import InputContext from '../../../Contexts/Input.Context'
import TemplateDataContext from '../../../Contexts/TemplateData.context'

type Props = {
    formElement: TemplateObject,
    handleSelectInput: Function,
    showLabel?: boolean
}

const InputSelect = ({ formElement, handleSelectInput, showLabel = true }: Props) => {
    /* Error : Uncaught TypeError: Cannot assign to read only property '' of object '#<Object>' Issue Fix */
    formElement = produce(formElement, (draft: { options: TemplateObject[] }) => {
        draft.options = formElement.options.map((formOption: TemplateObject) => ({ ...formOption, label: formOption.text }))
    })
    const { state } = useContext(FormDataContext)
    const { setConditionalInput } = useContext(InputContext)
    const { formData } = state
    const { state: templateState } = useContext(TemplateDataContext);
    const { selectedState, templatePath } = templateState;
    let selectedIndex:any = '';

    /* add more fields */
    const loadFields = (e: TemplateObject) => {
        let conditionalInput: null | TemplateObject = null
        /* Add more Fields based upon any selected value */
        if (e.value !== '' && formElement[jsonKeyMapping.FORM_INPUT_RADIO_MORE_FIELDS] !== undefined) {
            conditionalInput = {
                formElement: formElement[jsonKeyMapping.FORM_INPUT_RADIO_MORE_FIELDS],
                parentLabel: formElement[jsonKeyMapping.FORM_LABEL],
                value: formElement[jsonKeyMapping.FORM_VALUE]
            }
        }

        const hasMoreFields = formElement.options.find((option: TemplateObject) => (e.value === option[jsonKeyMapping.FORM_VALUE] && option[jsonKeyMapping.FORM_INPUT_RADIO_MORE_FIELDS] !== undefined))
        /* Add more Fields based upon selected value */
        if (e.value !== '' && hasMoreFields) {
            conditionalInput = {
                formElement: hasMoreFields[jsonKeyMapping.FORM_INPUT_RADIO_MORE_FIELDS],
                parentLabel: formElement[jsonKeyMapping.FORM_ID],
                value: hasMoreFields[jsonKeyMapping.FORM_LABEL]
            }
        }

        setConditionalInput(conditionalInput)
        handleSelectInput(e, formElement[jsonKeyMapping.FORM_ID])
    }
    if (templatePath.indexOf('state-specific') > -1) {
        if(selectedState !== ""){
            if(!!formData[formElement.id] || formData[formElement.id] === ""){
                selectedIndex = formElement.options.find((option: TemplateObject) => (option[jsonKeyMapping.FORM_VALUE] === formData[formElement[jsonKeyMapping.FORM_ID]])) || null
            }else{
                selectedIndex = formElement.options.find((option: TemplateObject) =>{
                    if(option[jsonKeyMapping.FORM_TEXT].replace(/ /g, '').toLocaleLowerCase() === selectedState){
                        return option[jsonKeyMapping.FORM_VALUE]
                      }
                }) || null
                if(formData[formElement[jsonKeyMapping.FORM_ID]] === undefined && selectedIndex !== null){
                    setTimeout(() => {
                        loadFields(selectedIndex)
                      }, 3000);
                }
            }
        }else{
            selectedIndex = formElement.options.find((option: TemplateObject) => (option[jsonKeyMapping.FORM_VALUE] === formData[formElement[jsonKeyMapping.FORM_ID]])) || null
        }

    }else{
         selectedIndex = formElement.options.find((option: TemplateObject) => (option[jsonKeyMapping.FORM_VALUE] === formData[formElement[jsonKeyMapping.FORM_ID]])) || null
    }
    return (
        <InputWrapper
            formElement={formElement}
            label={formElement[jsonKeyMapping.FORM_LABEL] || ''}
            labelsub={''}
            subtext={''}
        >
            <Select
                id={formElement[jsonKeyMapping.FORM_ID]}
                value={selectedIndex}
                //defaultValue={selectedIndex}
                isMulti={formElement.multiple}
                options={formElement.options}
                name={formElement[jsonKeyMapping.FORM_ID]}
                placeholder={formElement.options[0]?.text || ''}
                className={`basic-multi-select ${formElement.inputClass || ''}`}
                classNamePrefix="select"
                onChange={(e) => loadFields(e)}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999,marginTop:-8 }) }}
                minMenuHeight={220}
            />
               {formElement[jsonKeyMapping.FORM_SUBTEXT] && <><div><small className="form-text text-muted subtext  d-md-block">{formElement[jsonKeyMapping.FORM_SUBTEXT] || ''}</small></div></>}
        </InputWrapper>
    )
}

export default InputSelect
